function UsersServiceSyncCtrl($scope, $timeout) {
    $scope.syncScimProtoIdRequest = {
        result: null,
        accountsIdsStr: null,
    };

    $scope.userConnectivityMigrationRequest = {
        result: null,
        accountsIdsStr: null,
    }

    $scope.syncUsersServiceRequest = {
        result: null,
        accountsIdsStr: null,
        importType: null,
        sendSnapshot: false,
        startFrom: null,
        syncDates: false
    };
    $scope.syncUsersServiceWithUsersProjectionsRequest = {
        result: null,
        accountsIdsStr: null,
        whiteListProtoIdsStr: "",
        migrateColumnsStr: null,
        syncDates: false,
    };
    $scope.syncUsersServiceCredentialsRequest = {
        result: null,
        accountsIdsStr: null,
        syncDates: false,
    };

    $scope.syncUsersServiceSingleUserRequest = {
        result: null,
        accountId: null,
        importType: null,
        protoId: null,
        syncDates: false
    };

    $scope.syncUsersServiceSingleUsersGroupRequest = {
        result: null,
        accountId: null,
        importType: null,
        protoId: null,
        syncDates: false
    };

    $scope.syncAccountLicensesRequest = {
        result: null,
        accountsIdsStr: null,
    };
    $scope.syncAccountConfigsRequest = {
        result: null,
        accountsIdsStr: null,
    };

    $scope.sendSyncScimProtoId = function (request) {
        $scope.$root.confirm('Are you sure you want to sync protoIds for accounts: ' + request.accountsIdsStr + '?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: `/ag/syncScimProtoId?accountsIdsStr=${request.accountsIdsStr}`,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncScimProtoIdRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncScimProtoIdRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.migrateUserServiceConnectivity = function (request) {
        $scope.$root.confirm('Are you sure you want to migrate accounts: ' + request.accountsIdsStr + ' to US connectivity?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: `/ag/migrateUserServiceConnectivity?accountsIdsStr=${request.accountsIdsStr}`,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.userConnectivityMigrationRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.userConnectivityMigrationRequest.result = data;
                    }
                });
            });
        });
    }

    $scope.rollbackUserServiceConnectivity = function (request) {
        $scope.$root.confirm('Are you sure you want to rollback accounts: ' + request.accountsIdsStr + ' from US connectivity?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: `/ag/rollbackUserServiceConnectivity?accountsIdsStr=${request.accountsIdsStr}`,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.userConnectivityMigrationRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.userConnectivityMigrationRequest.result = data;
                    }
                });
            });
        });
    }

    $scope.sendSyncUserService = function (request) {
        $scope.$root.confirm('Are you sure you want to sync accounts with import type ' + request.importType + ': ' + request.accountsIdsStr + ' to US?', function () {
            $scope.syncUsersServiceRequest.result = null;
            let startProp = request.startFrom ? `&startFrom=${request.startFrom.getTime()}` : ''
            let url = request
                ? `/ag/syncUsersService?accountsIdsStr=${request.accountsIdsStr}&syncType=${request.importType}&sendSnapshot=${request.sendSnapshot}${startProp}&syncDates=${request.syncDates}`
                : `/ag/syncUsersService?syncType=ALL&sendSnapshot=false`;
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: url,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncUsersServiceRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncUsersServiceRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.sendSyncUserServiceUsersProjections = function (request) {
        $scope.$root.confirm('Are you sure you want to sync fields: ' + request.migrateColumnsStr + ' for accounts: ' + request.accountsIdsStr + ' to US?', function () {
            $scope.syncUsersServiceWithUsersProjectionsRequest.result = null;
            return new Promise(function () {
                return store.fetch({
                    method: 'PUT',
                    url: '/ag/syncUsersServiceWithUsersProjections?accountsIdsStr=' + request.accountsIdsStr + '&whiteListProtoIdsStr=' + request.whiteListProtoIdsStr + '&migrateColumnsStr=' + request.migrateColumnsStr + '&syncDates=' + request.syncDates,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncUsersServiceWithUsersProjectionsRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncUsersServiceWithUsersProjectionsRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.sendSyncUserServiceSingleUser = function (request) {
        $scope.$root.confirm('Are you sure you want to sync user: ' + request.protoId + ' with import type: ' + request.importType + ' to US?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: '/ag/syncUsersServiceSingleUser?accountId=' + request.accountId + '&syncType=' + request.importType + '&protoId=' + request.protoId,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncUsersServiceSingleUserRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncUsersServiceSingleUserRequest.result = data;
                    }
                });
            });
        });
    };

   $scope.sendSyncUserServiceSingleUsersGroup = function (request) {
       $scope.$root.confirm('Are you sure you want to sync users group: ' + request.protoId + ' with import type: ' + request.importType + ' to US?', function () {
           $scope.syncUsersServiceSingleUsersGroupRequest.result = null
           return new Promise(() => {
               return store.fetch({
                   method: 'PUT',
                   url: '/ag/syncUsersServiceSingleUsersGroup?accountId=' + request.accountId + '&protoId=' + request.protoId + '&syncType=' + request.importType + '&syncDates=' + request.syncDates,
                   success: function success(data) {
                       $timeout(function () {
                           $scope.syncUsersServiceSingleUsersGroupRequest.result = data;
                       }, 0);
                   },
                   error: function error(data) {
                       $scope.syncUsersServiceSingleUsersGroupRequest.result = data;
                   }
               });
           });
       });
    };

    $scope.syncAccountLicenses = function (request) {
        $scope.$root.confirm('Are you sure you want to sync account license configuration for accounts: ' + request.accountsIdsStr + ' to US?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'POST',
                    url: '/ag/syncAccountLicenses?accountsIdsStr=' + request.accountsIdsStr,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncAccountLicensesRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncAccountLicensesRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.syncAllAccountLicenses = function () {
        $scope.$root.confirm('Are you sure you want to sync account license configuration for ALL accounts ?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'POST',
                    url: '/ag/syncAllAccountLicenses',
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncAccountLicensesRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncAccountLicensesRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.sendSyncUserServiceCredentials = function (request) {
        $scope.$root.confirm('Are you sure you want to sync credentials for accounts: ' + request.accountsIdsStr + ' to US?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: '/ag/sendSyncUserServiceCredentials?accountsIdsStr=' + request.accountsIdsStr + '&syncDates=' + request.syncDates,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncUsersServiceCredentialsRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncUsersServiceCredentialsRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.syncUsersServiceAccountAuthMethod = function (request) {
        $scope.$root.confirm('Are you sure you want to sync authentication methods for accounts: ' + request.accountsIdsStr + ' to US?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: '/ag/syncUsersServiceAccountAuthMethod?accountsIdsStr=' + request.accountsIdsStr,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncAccountConfigsRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncAccountConfigsRequest.result = data;
                    }
                });
            });
        });
    };

    $scope.syncUsersServiceAccountIdp = function (request) {
        $scope.$root.confirm('Are you sure you want to sync account IDP for accounts: ' + request.accountsIdsStr + ' to US?', function () {
            return new Promise(() => {
                return store.fetch({
                    method: 'PUT',
                    url: '/ag/syncUsersServiceAccountIdp?accountsIdsStr=' + request.accountsIdsStr,
                    success: function success(data) {
                        $timeout(function () {
                            $scope.syncAccountConfigsRequest.result = data;
                        }, 0);
                    },
                    error: function error(data) {
                        $scope.syncAccountConfigsRequest.result = data;
                    }
                });
            });
        });
    };
}